// extracted by mini-css-extract-plugin
module.exports = {"all":"landingPage_all__vz5p0","headingBox":"landingPage_headingBox__raqfU","heading":"landingPage_heading__2Bcgm"};